// Бэкенд пишет расчет в историю за 1–2.5 с, берем с запасом
export const BITRIX_USER_HISTORY_REFRESH_DELAY_MS = 5000;

// Бэкенд привязывает созданное ИП к пользователю асинхронно (до ~3 с)
export const INDIVIDUAL_OFFERS_REFRESH_DELAY_MS = 5000;
